import React from "react";

import Typography from "_components/atoms/typography";

import ProgressIndicator from "../progressIndicator";

import useStyles from "./styles";

const ProgressOptions = ( { options, options1, seperatorText } ) => {

	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<>
			{options?.map ( ( data, idx ) => {
				return (
					<ProgressIndicator
						key  = { idx }
						data = { data }
					/>
				);
			} )}

			{options1 && (
				<Typography
					className = { classes.seperator }
					title     = { seperatorText }
				/>

			)}

			{options1?.map ( ( data, idx ) => {
				return (
					<ProgressIndicator
						key  = { idx }
						data = { data }
					/>
				);
			} )}
		</>
	);
};

export default ProgressOptions;